function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from "react";
import { InputEmail } from "../../../helperComponents/";
import "./client_emails.scss";

var ClientEmails = function ClientEmails(props) {
  var onChange = props.onChange,
      user = props.user,
      _props$onlyOneEmail = props.onlyOneEmail,
      onlyOneEmail = _props$onlyOneEmail === void 0 ? false : _props$onlyOneEmail,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled; // if there is no main email, add to the first position

  if (user.emails.length !== 0 && !user.emails.find(function (email) {
    return email.is_main;
  })) {
    var newEmails = _toConsumableArray(user.emails);

    newEmails[0].is_main = true;
    onChange(_toConsumableArray(newEmails));
  }

  var handleOnChange = function handleOnChange(event, index) {
    // Get email with replaced value
    var newUSerEmails = user.emails.map(function (userEmail, indexEmail) {
      if (index === indexEmail && index === 0) {
        return _objectSpread(_objectSpread({}, userEmail), {}, {
          email: event.target.value,
          is_main: true
        });
      }

      if (index === indexEmail) {
        return _objectSpread(_objectSpread({}, userEmail), {}, {
          email: event.target.value
        });
      }

      return userEmail;
    });
    onChange(_toConsumableArray(newUSerEmails));
  };

  var handleAddEmail = function handleAddEmail(is_main) {
    var newEmail = _toConsumableArray(user.emails);

    newEmail.push({
      user_id: user === null || user === void 0 ? void 0 : user.id,
      is_main: is_main || false,
      email: ""
    });
    onChange(_toConsumableArray(newEmail));
  };

  var handleRemoveEmail = function handleRemoveEmail(index) {
    var newEmail = user.emails.filter(function (email, index_email) {
      return index_email !== index;
    });
    onChange(newEmail);
  };

  React.useEffect(function () {
    if (user.emails.length === 0) handleAddEmail(true);
  }, [user]);
  return /*#__PURE__*/React.createElement("div", {
    className: "conteinerFluid cntClientEmails"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 inputEmail"
  }, user.emails.map(function (email, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "user_emails_list-".concat(index)
    }, index === 1 && /*#__PURE__*/React.createElement("strong", {
      className: "emailSecondaryLabel"
    }, "Emails Secundarios"), /*#__PURE__*/React.createElement(InputEmail, {
      key: index,
      value: email.email,
      hideLabel: index > 0,
      disableRemoveButon: index === 0 || disabled,
      onRemove: function onRemove() {
        return handleRemoveEmail(index);
      },
      disabled: disabled,
      classNameInput: "form-control ",
      onChange: function onChange(event) {
        return handleOnChange(event, index);
      }
    }));
  })), !onlyOneEmail && !disabled && /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 buttonPlus "
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-block",
    onClick: handleAddEmail
  }, "+")));
};

export default ClientEmails;